import styled from 'styled-components';

export const DEIPageLegendDIV = styled.div`
  width: 100%;
  max-width: 400px;
  box-shadow: var(--elevation--S);
  border-radius: 4px;
`;

export const DEIPageLegendTypeDIV = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 70px;
  background: white;
  overflow: hidden;
  box-shadow: inset 0 -1px 1px var(--color--charcoal-200);
  transition: all 0.4s;
  cursor: pointer;

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  &:hover {
    position: relative;
    z-index: 1;
    transform: scale(1.05);
    border-radius: 4px;
    box-shadow: var(--elevation--M);
  }

  img {
    height: 70px;
    width: 15px;
    margin-right: 20px;
  }

  span {
    font-weight: 600;
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    color: var(--color--text-headline);
    font-size: var(--font-size--L);
  }
`;
